export const Order_req="Order_req";
export const Order_success="Order_success";
export const Order_fail="Order_fail";
export const Order_reset="Order_reset";

export const Order_details_req="Order_details_req";
export const Order_details_success="Order_success";
export const Order_details_fail="Order_fail";
export const Order_details_reset="Order_reset";

export const Pay_req="Pay_req";
export const Pay_success="Pay_success";
export const Pay_fail="Pay_fail";
export const Pay_reset="Pay_reset";